import { Popper, Paper, ClickAwayListener, LinearProgress, Box } from '@mui/material';
import { useFeatures } from 'hooks/useFeatures';
import { ghostClickDebounce } from 'utils/ghostClickDebounce';
import { SelectOption } from 'generated/graphql';
import SearchResultsPanel from './SearchResultsPanel';

const DesktopSearchResults = ({
  open,
  anchorRef,
  inputValue,
  filteredOptions,
  isFetching = false,
  isDisabled = false,
  hasNextPage = false,
  isFetchingMore = false,
  onResultClick,
  onAdd,
  onLoadMore = () => {},
  setOpen,
}: {
  open: boolean;
  anchorRef: React.RefObject<HTMLDivElement | null>;
  inputValue: string;
  filteredOptions: SelectOption[];
  isFetching?: boolean;
  isDisabled?: boolean;
  hasNextPage?: boolean;
  isFetchingMore?: boolean;
  onResultClick: (option: string, optionEntityID: string) => void;
  onAdd?: () => void;
  onLoadMore?: () => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { isEnabled } = useFeatures();
  const isQuotesSearchEnabled = isEnabled('QuotesSearch');

  if (!open || isDisabled) return null;

  return (
    <Popper
      open={open}
      anchorEl={anchorRef.current}
      placement="bottom-start"
      style={{ zIndex: 1300, width: anchorRef.current?.offsetWidth }}
    >
      <ClickAwayListener // If user removes focus from the SearchInputField or popper in DesktopSearchResults, then close the popper
        onClickAway={() => {
          ghostClickDebounce(() => setOpen(false)); // Small delay to avoid any ghost clicks when popper closes
        }}
      >
        <Paper elevation={4} sx={{ position: 'relative', overflow: 'hidden' }}>
          <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1, height: 3 }} aria-live="polite">
            {isFetching && <LinearProgress aria-label="Searching" />}
          </Box>

          <SearchResultsPanel
            inputValue={inputValue}
            filteredOptions={filteredOptions}
            isFetching={isFetching}
            hasNextPage={hasNextPage}
            isFetchingMore={isFetchingMore}
            maxHeight={isQuotesSearchEnabled ? '50vh' : undefined}
            onResultClick={onResultClick}
            onAdd={onAdd}
            onLoadMore={onLoadMore}
          />
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

export default DesktopSearchResults;
